module.exports = __webpack_public_path__ + "static/media/tracking8.ccaef961.png";